<form
  class="kt-form"
  [formGroup]="quoteForm"
  autocomplete="off"
  [ngClass]="{ submitted: submitted }"
>
  <div class="modal-header">
    <h4 class="modal-title">{{ pageTitle }}</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss('')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <h4 class="form-error text-center text-danger" *ngIf="showFormError">
      Please fill in all the required fields.
    </h4>

    <mat-tab-group
      mat-align-tabs="center"
      dynamicHeight
      [selectedIndex]="activeTab"
      (selectedIndexChange)="gotoTab($event)"
      *ngIf="quoteForm.value.rfq_quote_type == 16"
    >
      <mat-tab label="{{ 'TITLES.PRODUCT_INFO' | translate }}">
        <div class="row w1024">
          <div class="col-md-6">
            <div class="form-group">
              <label>Product Type</label>
              <select
                class="form-control"
                formControlName="type"
                (change)="onProductTypeChange()"
              >
                <option [value]="productTypes.PRODUCT">
                  {{ productTypes.PRODUCT }}
                </option>
                <option [value]="productTypes.KIT">
                  {{ productTypes.KIT }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label for="" [translate]="'LABELS.PRODUCT_NAME'">Product Name</label>
              <input
                type="text"
                class="form-control"
                placeholder="{{ 'LABELS.PRODUCT_NAME' | translate }}"
                formControlName="product_name"
              />
              <control-messages
                [submitted]="submitted"
                [control]="quoteForm.controls.product_name"
                [minlength]="8"
              >
              </control-messages>
            </div>
            <div class="form-group">
              <label for="">Internal SKU</label>
              <div class="position-relative">
                <input
                  type="text"
                  class="form-control"
                  formControlName="internal_sku"
                />
                <mat-spinner
                  *ngIf="!rfq && (generatingSku$ | async)"
                  [diameter]="15"
                  class="generating-sku-loader"
                >
                </mat-spinner>
              </div>
              <control-messages
                [submitted]="submitted"
                [control]="quoteForm.controls.internal_sku"
              >
              </control-messages>
            </div>
            <div class="form-group">
              <label for="">UPC</label>
              <input
                type="text"
                class="form-control"
                formControlName="upc"
                maxlength="50"
              />
              <control-messages
                [submitted]="submitted"
                [control]="quoteForm.controls.upc"
              >
              </control-messages>
            </div>
            <div class="form-group">
              <label for="" [translate]="'LABELS.PRODUCT_CATEGORY'"
                >Product Category</label
              >
              <select
                class="form-control"
                formControlName="product_category_id"
                (change)="setSubCategory()"
              >
                <option
                  [value]="bt.id"
                  *ngFor="let bt of productCategoriesSvc._productCategories | async"
                >
                  {{ bt.product_category }}
                </option>
              </select>
              <control-messages
                [submitted]="submitted"
                [control]="quoteForm.controls.product_category_id"
              >
              </control-messages>
            </div>

            <div
              class="form-group"
              *ngIf="selectedCategory && selectedCategory.sub_categories"
            >
              <label for="">Product Sub Category</label>
              <select class="form-control" formControlName="sub_category_id">
                <option [value]="0"></option>
                <option
                  *ngFor="let bt of selectedCategory.sub_categories"
                  [value]="bt.id"
                >
                  {{ bt.sub_category }}
                </option>
              </select>
              <control-messages
                [submitted]="submitted"
                [control]="quoteForm.controls.product_category_id"
              >
              </control-messages>
            </div>

            <div class="form-group">
              <label for="">Tax Category</label>
              <input class="form-control" formControlName="tax_category" />
              <control-messages
                [submitted]="submitted"
                [control]="quoteForm.controls.tax_category"
              >
              </control-messages>
            </div>

            <div class="form-group">
              <label for="">Preferred Supplier</label>
              <ng-select
                [items]="factories"
                formControlName="preferred_vendor_id"
                bindLabel="factory_name"
                bindValue="id"
              >
              </ng-select>
            </div>

            <div
              class="form-group"
              *ngIf="featureFlag.ASSEMBLY_ORDER | featureFlag"
            >
              <label for="">Bill of Materials</label>
              <ng-select
                formControlName="bom_ids"
                [items]="boms"
                bindValue="id"
                bindLabel="name"
                [typeahead]="bomInput$"
                [trackByFn]="trackBomByFn"
                [loading]="bomLoading"
                multiple="true"
              >
              </ng-select>
              <control-messages
                [submitted]="submitted"
                [control]="quoteForm.controls.bom_ids"
              >
              </control-messages>
            </div>

            <div class="form-group" *ngIf="lotTrackingEnabled && !isKit">
              <mat-checkbox color="primary" formControlName="lot_tracking">
                Lot Tracking
              </mat-checkbox>
            </div>

            <div class="form-group" *ngIf="!isKit">
              <mat-checkbox color="primary" formControlName="sellable">
                Sellable
              </mat-checkbox>
            </div>

            <div
              class="form-group"
              *ngIf="parentSku || (rfq && rfq.variant_parent_id > 0)"
            >
              <label for="">Inventory Tracking</label>
              <div>
                <mat-checkbox
                  color="primary"
                  formControlName="mirror_inventory_from_parent"
                >
                  Mirror inventory from parent master SKU
                </mat-checkbox>
              </div>
              <small>Master parent SKU tracks inventory for this Variant SKU</small>
            </div>
          </div>

          <div class="col-md-6">
            <!-- <div class="form-group" *ngIf="product_type">
							<label for="">Product Type</label>
							<select class="form-control" formControlName="product_type_id">
								<option [value]="pt.id" *ngFor="let pt of settingsSvc.productTypes">
									{{pt.text}}</option>
							</select>
							<control-messages [submitted]="submitted" [control]="quoteForm.controls.product_type_id">
							</control-messages>
						</div> -->

            <div
              class="form-group"
              *ngIf="featureFlag.REMOVE_PRODUCT_DEPARTMENT | featureFlag"
            >
              <label for="">Product Department</label>
              <select class="form-control" formControlName="product_dept_id">
                <option
                  *ngFor="let pt of settingsSvc.productDepartments"
                  [value]="pt.id"
                >
                  {{ pt.text }}
                </option>
              </select>
              <control-messages
                [submitted]="submitted"
                [control]="quoteForm.controls.product_dept_id"
              >
              </control-messages>
            </div>

            <div class="form-group" *ngIf="quoteForm.value.product_type_id == 2">
              <div class="row">
                <div class="col-md-4">
                  <label for="">Re-Order Level</label>
                  <input
                    type="number"
                    class="form-control"
                    formControlName="reorder_level"
                    min="0"
                    numberOnly
                  />
                </div>
                <div class="col-md-4">
                  <label for="">Low Stock Alert Quantity</label>
                  <input
                    type="number"
                    class="form-control"
                    formControlName="qty_limit_notify"
                    min="0"
                    numberOnly
                  />
                </div>
                <div class="col-md-4">
                  <label for="">Minimum Stock</label>
                  <input
                    type="number"
                    class="form-control"
                    formControlName="oss_limit_notify"
                    min="0"
                    numberOnly
                  />
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-md-4">
                  <label for="">Wholesale Price</label>
                  <input
                    type="number"
                    class="form-control"
                    formControlName="wholesale_price"
                    min="0"
                    numberOnly
                  />
                </div>
                <div class="col-md-4">
                  <label for="">Retail Price</label>
                  <input
                    type="number"
                    class="form-control"
                    formControlName="retail_price"
                    min="0"
                    numberOnly
                  />
                </div>
                <div class="col-md-4" *ngIf="canReadUnitCost">
                  <label for="">Unit Cost</label>
                  <input
                    type="number"
                    class="form-control"
                    formControlName="unitCost"
                  />
                </div>
              </div>
            </div>

            <div
              class="form-group"
              *ngIf="(featureFlag.ADD_RFQ_LEAD_TIME | featureFlag) && rfq?.id"
            >
              <div class="row">
                <div class="col-md-4">
                  <label for="">Lead Time</label>
                  <input
                    type="number"
                    class="form-control"
                    formControlName="lead_time"
                    min="0"
                    numberOnly
                  />
                </div>
              </div>
            </div>

            <div class="form-group">
              <label>
                <mat-checkbox
                  color="primary"
                  [checked]="quote_expires"
                  (change)="quote_expires = !quote_expires"
                ></mat-checkbox>
                Quote expires?
              </label>
              <input
                type="date"
                class="form-control"
                *ngIf="quote_expires"
                formControlName="expires_at"
              />
            </div>

            <div class="form-group">
              <mat-checkbox color="primary" formControlName="internal_use_only">
                Internal Use Only
              </mat-checkbox>
            </div>

            <div class="form-group">
              <label>Product Tags</label>
              <ng-select
                [items]="tags"
                formControlName="product_tags"
                bindValue="id"
                [searchFn]="customTagsSearchFn"
                multiple="true"
              >
                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                  <span
                    class="ng-value-icon right"
                    (click)="clear(item)"
                    aria-hidden="true"
                    >×</span
                  >
                  <span [innerHTML]="item.name" class="d-inline"></span>
                </ng-template>
                <ng-template
                  ng-option-tmp
                  let-item="item"
                  let-index="index"
                  let-search="searchTerm"
                >
                  <h6 [innerHTML]="item.name"></h6>
                </ng-template>
              </ng-select>
            </div>

            <div class="form-group" *ngIf="!isKitAndEnabledKitStructure">
              <label for="">Unit Class</label>
              <ng-select
                formControlName="unit_class_id"
                [items]="unitClasses$ | async"
                bindValue="id"
                bindLabel="name"
                [multiple]="false"
                [typeahead]="unitClassInput$"
                [trackByFn]="trackUnitClassByFn"
                [loading]="unitClassLoading"
                (change)="setUnitClass()"
                [clearable]="true"
              >
              </ng-select>
              <control-messages
                [submitted]="submitted"
                [control]="quoteForm.controls.unit_class_id"
              >
              </control-messages>
            </div>

            <div class="form-group" *ngIf="!isKitAndEnabledKitStructure">
              <label for="">Selling Unit</label>
              <ng-select
                formControlName="default_selling_unit_id"
                [items]="unitMeasures$ | async"
                bindValue="id"
                bindLabel="name"
                [typeahead]="unitMeasureInput$"
                [trackByFn]="trackunitMeasureByFn"
                [loading]="unitMeasureLoading"
              >
              </ng-select>
              <control-messages
                [submitted]="submitted"
                [control]="quoteForm.controls.default_selling_unit_id"
              >
              </control-messages>
            </div>

            <div class="form-group" *ngIf="!isKitAndEnabledKitStructure">
              <label for="">Purchase Unit</label>
              <ng-select
                formControlName="default_purchase_unit_id"
                [items]="unitMeasures$ | async"
                bindValue="id"
                bindLabel="name"
                [typeahead]="unitMeasureInput$"
                [trackByFn]="trackunitMeasureByFn"
                [loading]="unitMeasureLoading"
              >
              </ng-select>
              <control-messages
                [submitted]="submitted"
                [control]="quoteForm.controls.default_purchase_unit_id"
              >
              </control-messages>
            </div>

            <div class="form-group">
              <label for="">Default Receiving Bin</label>
              <ng-select
                formControlName="default_receiving_bin_id"
                [items]="defaultWarehouseLocations$ | async"
                bindValue="id"
                bindLabel="locationName"
                [typeahead]="defaultWarehouseLocationInput$"
                [trackByFn]="trackDefaultWarehouseLocationByFn"
                [loading]="gettingDefaultWarehouseLocations$ | async"
              >
              </ng-select>
              <control-messages
                [submitted]="submitted"
                [control]="quoteForm.controls.default_receiving_bin_id"
              >
              </control-messages>
            </div>

            <div
              class="form-group"
              *ngIf="'red_DV-3362_fo_shipment_splits' | featureFlag"
            >
              <label for="">Fulfillment Priority List</label>
              <ng-select
                formControlName="fulfillment_priority_list_id"
                [items]="fulfillmentPriorityList"
                bindValue="id"
                bindLabel="name"
                [typeahead]="fulfillmentPriorityListInput$"
                [trackByFn]="trackById"
                [loading]="fulfillmentPriorityListLoading"
              >
              </ng-select>
            </div>

            <div class="form-group">
              <mat-checkbox
                color="primary"
                formControlName="is_fulfill_separately"
                *ngIf="'red_DV-3362_fo_shipment_splits' | featureFlag"
              >
                Always Fulfill Separately
              </mat-checkbox>
            </div>
          </div>
        </div>

        <div class="row w1024 mt-2">
          <div class="col-md-12">
            <div class="form-group">
              <label for="">Product Image URL</label>
              <input
                type="text"
                class="form-control"
                formControlName="photo"
                placeholder="ex. https://placehold.co/400.png"
              />
            </div>
            <div class="form-group">
              <label for="">Product Design URL</label>
              <input
                type="text"
                class="form-control"
                formControlName="product_design"
                placeholder="ex. https://..."
              />
            </div>

            <div class="form-group">
              <label>
                Product Listings
                <small class="text-cloud-600"
                  >Links to this product's customer-facing listings on external
                  marketplaces and storefronts.</small
                >
              </label>
              <div formArrayName="product_links">
                <ng-container
                  *ngFor="
                    let rmk of quoteForm['controls'].product_links['controls'];
                    let idx = index
                  "
                >
                  <div [formGroupName]="idx" class="form-group d-flex gap-x-2">
                    <input
                      type="text"
                      class="form-control"
                      formControlName="lv"
                      placeholder="ex. https://www.amazon.com/dp/0762486082"
                    />
                    <button
                      *ngIf="idx == 0"
                      type="button"
                      class="lum-button lum-button--link"
                      (click)="addLink('product_links')"
                      aria-label="Add Another Product Listing Link"
                      ><i class="fa-fw fas fa-plus"></i
                    ></button>
                    <button
                      *ngIf="idx > 0"
                      type="button"
                      class="lum-button lum-button--link"
                      (click)="removeLink('product_links', idx)"
                      aria-label="Remove This Product Listing Link"
                      ><i class="fa-fw fas fa-times text-cloud-500"></i
                    ></button>
                  </div>
                </ng-container>
              </div>
            </div>

            <div class="form-group">
              <label for="" [translate]="'LABELS.PRODUCT_DESCRIPTION'"
                >Product Description</label
              >
              <angular-editor
                name="product_description"
                formControlName="product_description"
                [config]="config"
              >
              </angular-editor>
              <control-messages
                [submitted]="submitted"
                [control]="quoteForm.controls.product_description"
              >
              </control-messages>
            </div>

            <details class="mt-8">
              <summary><h5 class="d-inline">Legacy Fields</h5></summary>
              <div class="pl-6 mt-3">
                <div class="form-group">
                  <label>
                    Materials
                    <small class="text-cloud-600"
                      >Consider creating a Bill of Materials instead.</small
                    >
                  </label>
                  <div formArrayName="material">
                    <ng-container
                      *ngFor="
                        let rmk of quoteForm['controls'].material['controls'];
                        let idx = index
                      "
                    >
                      <div [formGroupName]="idx" class="d-flex gap-x-2">
                        <input
                          type="text"
                          class="form-control"
                          formControlName="mv"
                        />
                        <button
                          *ngIf="idx == 0"
                          type="button"
                          class="lum-button lum-button--link"
                          (click)="addMaterials('material')"
                          aria-label="Add Another Material Entry"
                          ><i class="fas fa-plus"></i
                        ></button>
                        <button
                          *ngIf="idx > 0"
                          type="button"
                          class="lum-button lum-button--link"
                          (click)="removeMaterials('material', idx)"
                          aria-label="Remove This Material Entry"
                          ><i class="fas fa-times text-cloud-500"></i
                        ></button>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </details>
          </div>
        </div>

        <div class="clearfix"></div>

        <div class="row w1024 action-button">
          <button
            type="button"
            class="btn btn-outline-info"
            (click)="gotoTab(activeTab + 1)"
            [translate]="'BUTTONS.NEXT'"
          >
            Next <i class="fas fa-arrow-right"></i>
          </button>
        </div>
      </mat-tab>

      <mat-tab *ngIf="showKitItems" label="Kit Items">
        <cnc-rfq-kit-items
          controlName="kitItems"
          [formGroup]="quoteForm"
          [items]="rfq?.kit_items || []"
        ></cnc-rfq-kit-items>
      </mat-tab>

      <mat-tab label="Product Substitutions">
        <lum-rfq-product-substitution-form
          (onProductSubstitutionDataEvent)="setProductSubstitutionData($event)"
          [productType]="quoteForm.getRawValue().type"
          [productId]="rfq && rfq.id ? rfq.id : 0"
        ></lum-rfq-product-substitution-form>
      </mat-tab>

      <mat-tab label="Variants" *ngIf="rfq && !(rfq.variant_parent_id > 0)">
        <div class="row mb-5 w1024">
          <div class="col-md-12">
            <fieldset>
              <legend>Product Variants</legend>
              <mat-checkbox color="primary" formControlName="product_has_variants">
                {{ 'LABELS.PRODUCT_HAS_VARIATION' | translate }}
              </mat-checkbox>
              <br />
              <table
                class="table table-striped"
                *ngIf="quoteForm.value.product_has_variants"
              >
                <thead>
                  <tr>
                    <th [translate]="'TITLES.VARIANT_NAME'">Variant Name</th>
                    <th [translate]="'TITLES.VARIANT_TERMS_VALUES'">
                      Terms / Values
                    </th>
                    <th class="text-right">
                      <a
                        class="btn btn-default text-uppercase text-primary btn-sm"
                        href="javascript:;"
                        (click)="addVariant()"
                        [translate]="'BUTTONS.ADD'"
                      >
                        <i class="fas fa-plus mr-2"></i> ADD
                      </a>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let variant of productVariants; let i = index">
                    <td class="text-capitalize">
                      {{ variant.variant_name }}
                    </td>
                    <td>
                      {{ variant?.variant_terms }}
                    </td>
                    <td class="actions text-right">
                      <a
                        href="javascript:;"
                        (click)="addVariant(variant, i)"
                        title="Edit"
                      >
                        <i class="fas fa-edit fa-fw"></i>
                      </a>
                      <a
                        href="javascript:;"
                        (click)="productVariants.splice(i, 1)"
                        class="text-danger"
                        title="Remove"
                      >
                        <i class="fas fa-trash fa-fw"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </fieldset>
          </div>
        </div>
        <div class="clearfix"></div>

        <div class="row w1024 action-button">
          <button
            type="button"
            class="btn btn-outline-info mr-1"
            (click)="gotoTab(activeTab - 1)"
            [translate]="'BUTTONS.BACK'"
          >
            <i class="fas fa-arrow-left"></i> Back
          </button>
          <button
            type="button"
            class="btn btn-outline-info"
            (click)="gotoTab(activeTab + 1)"
            [translate]="'BUTTONS.NEXT'"
          >
            Next <i class="fas fa-arrow-right"></i>
          </button>
        </div>
      </mat-tab>

      <mat-tab label="Attachments">
        <div class="row w1024">
          <div class="col-md-12">
            <fieldset class="file-upload">
              <legend [translate]="'TITLES.ATTACH_PRODUCT_FILES'">
                Attach Product Files / Pictures
              </legend>

              <div class="form-group">
                <input
                  type="file"
                  class="form-control"
                  id="files"
                  multiple
                  (change)="handleFileInput($event)"
                />
              </div>

              <div formArrayName="fileremarks">
                <table class="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th [translate]="'TITLES.FILE'">File</th>
                      <th [translate]="'TITLES.FILE_REMARKS'">
                        File Remarks/Description
                      </th>
                      <th>&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="
                        let rmk of quoteForm['controls'].fileremarks['controls'];
                        let idx = index
                      "
                    >
                      <td>
                        <img
                          [src]="filesToUpload[idx].previewSrc"
                          alt=""
                          width="60"
                          *ngIf="filesToUpload[idx].previewSrc != ''"
                        />
                        <span *ngIf="filesToUpload[idx].file">
                          {{ filesToUpload[idx].file.name }}
                        </span>
                      </td>
                      <td>
                        <span *ngIf="!filesToUpload[idx].file">{{
                          rmk.value | json
                        }}</span>
                        <input
                          *ngIf="filesToUpload[idx].file"
                          class="form-control"
                          type="text"
                          [formControlName]="idx"
                        />
                      </td>

                      <td class="actions">
                        <a
                          href="javascript:;"
                          class="text-danger"
                          title="Remove"
                          (click)="removeFile(idx)"
                        >
                          <i class="fas fa-trash"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot *ngIf="rfq && rfq.rfq_attachments">
                    <tr *ngFor="let file of rfq.rfq_attachments; let i = index">
                      <td>
                        <span></span>
                        <span *ngIf="file.thumburl">
                          <a
                            target="_blank"
                            href="{{ url + '/file?f=' + file.filename }}"
                          >
                            <img
                              src="{{ url + '/file?f=' + file.thumburl }}"
                              width="50"
                              alt="{{ file.fileurl }}"
                            />
                          </a>
                        </span>
                      </td>
                      <td>
                        {{ file.remarks }}
                      </td>
                      <td class="actions text-right">
                        <a
                          href="javascript:;"
                          class="text-danger"
                          title="Delete file"
                          (click)="deleteFile(file, i)"
                        >
                          <i class="fas fa-trash"></i>
                        </a>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </fieldset>
          </div>
        </div>
        <div class="clearfix"></div>

        <div class="row w1024 action-button">
          <button
            type="button"
            class="btn btn-outline-info mr-1"
            (click)="gotoTab(activeTab - 1)"
            [translate]="'BUTTONS.BACK'"
          >
            <i class="fas fa-arrow-left"></i> Back
          </button>
          <button
            type="button"
            class="btn btn-outline-info"
            (click)="gotoTab(activeTab + 1)"
            [translate]="'BUTTONS.NEXT'"
          >
            Next <i class="fas fa-arrow-right"></i>
          </button>
        </div>
      </mat-tab>

      <mat-tab label="{{ 'TITLES.SHIP_PACK_DETAILS' | translate }}">
        <div class="row w1280">
          <div class="col-md-6">
            <!-- 						<div class="form-group">
							<label for="">To Address</label>
							<textarea class="form-control" rows="3" formControlName="to_address"></textarea>
						</div>
						<div class="form-group">
							<label for="">From Address</label>
							<textarea class="form-control" rows="3" formControlName="from_address"></textarea>
						</div> -->

            <div class="form-group">
              <label for="">Shipment Value</label>
              <input
                type="number"
                class="form-control"
                formControlName="shipment_value"
                min="0"
                numberOnly
              />
            </div>

            <div
              class="form-group"
              *ngIf="settingsSvc.settings$ | async as settings"
            >
              <label for="">Efficiency Score</label>
              <select class="form-control" formControlName="efficiency_score">
                <option value="0">--- Select efficiency score ---</option>
                <option *ngFor="let es of settings.labor_costs" [value]="es.score">
                  {{ es.score }} => {{ es.cost | currency: '' }}
                </option>
              </select>
            </div>

            <!-- <div class="form-group">
                            <label for="">Labor Cost</label>
                            <input type="number" class="form-control" formControlName="labor_cost" numberOnly />
                        </div> -->

            <div class="form-group">
              <label for="">Package Cost ($)</label>
              <input
                type="number"
                class="form-control"
                formControlName="package_cost"
                min="0"
                numberOnly
              />
            </div>

            <div
              class="form-group"
              *ngIf="
                shippingCarrierSvc.shippingCarriers$ | async as shippingCarriers
              "
            >
              <label for="">Set Default Shipping</label>
              <select formControlName="default_shipping" class="form-control">
                <option value="0">--- Select default shipping ---</option>
                <option *ngFor="let sh of shippingCarriers.data" [value]="sh.id">
                  {{ sh.carrier_name }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-md-6">
            <h6>Product Dimension</h6>
            <div class="form-group form-inline">
              <label for="">Weight</label>
              <div class="weights" formArrayName="productWeights">
                <div
                  class="form-inline"
                  *ngFor="
                    let rmk of quoteForm['controls'].productWeights['controls'];
                    let idx = index
                  "
                >
                  <div [formGroupName]="idx">
                    <input
                      type="number"
                      class="form-control"
                      formControlName="wv"
                      min="0"
                      numberOnly
                    />
                    <select class="form-control" formControlName="mu">
                      <option
                        *ngFor="let unit of rfqService.weightUnits"
                        [value]="unit"
                      >
                        {{ unit }}
                      </option>
                    </select>
                    <a
                      href="javascript:;"
                      class="mx-2"
                      (click)="addWeight('productWeights')"
                      *ngIf="idx == 0"
                    >
                      <i class="fas fa-plus"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="mx-2"
                      (click)="removeWeight('productWeights', idx)"
                      *ngIf="idx > 0"
                    >
                      <i class="fas fa-times text-danger"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group form-inline">
              <label for="">Dimensions (in)</label>
              <input
                type="number"
                class="form-control mr-1"
                formControlName="product_length"
                min="0"
                numberOnly
              />
              <input
                type="number"
                class="form-control mr-1"
                formControlName="product_width"
                min="0"
                numberOnly
              />
              <input
                type="number"
                class="form-control mr-1"
                formControlName="product_height"
                min="0"
                numberOnly
              />
            </div>

            <h6>Shipping Dimension</h6>

            <div class="form-group form-inline">
              <label for="">Weight</label>
              <div class="weights" formArrayName="shippingWeights">
                <div
                  class="form-inline"
                  *ngFor="
                    let rmk of quoteForm['controls'].shippingWeights['controls'];
                    let idx = index
                  "
                >
                  <div [formGroupName]="idx">
                    <input
                      type="number"
                      class="form-control"
                      formControlName="wv"
                      min="0"
                      numberOnly
                    />
                    <select class="form-control" formControlName="mu">
                      <option
                        *ngFor="let unit of rfqService.weightUnits"
                        [value]="unit"
                      >
                        {{ unit }}
                      </option>
                    </select>
                    <a
                      href="javascript:;"
                      class="mx-2"
                      (click)="addWeight('shippingWeights')"
                      *ngIf="idx == 0"
                    >
                      <i class="fas fa-plus"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="mx-2"
                      (click)="removeWeight('shippingWeights', idx)"
                      *ngIf="idx > 0"
                    >
                      <i class="fas fa-times text-danger"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group form-inline">
              <label for="">Dimensions (in)</label>
              <input
                type="number"
                class="form-control mr-1"
                formControlName="shipping_length"
                min="0"
                numberOnly
              />
              <input
                type="number"
                class="form-control mr-1"
                formControlName="shipping_width"
                min="0"
                numberOnly
              />
              <input
                type="number"
                class="form-control mr-1"
                formControlName="shipping_height"
                min="0"
                numberOnly
              />
            </div>

            <h6>Box Dimension</h6>

            <div class="form-group form-inline">
              <label for="">Weight</label>
              <div class="weights" formArrayName="boxWeights">
                <div
                  class="form-inline"
                  *ngFor="
                    let rmk of quoteForm['controls'].boxWeights['controls'];
                    let idx = index
                  "
                >
                  <div [formGroupName]="idx">
                    <input
                      type="number"
                      class="form-control"
                      formControlName="wv"
                      min="0"
                      numberOnly
                    />
                    <select class="form-control" formControlName="mu">
                      <option
                        *ngFor="let unit of rfqService.weightUnits"
                        [value]="unit"
                      >
                        {{ unit }}
                      </option>
                    </select>
                    <a
                      href="javascript:;"
                      class="mx-2"
                      (click)="addWeight('boxWeights')"
                      *ngIf="idx == 0"
                    >
                      <i class="fas fa-plus"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="mx-2"
                      (click)="removeWeight('boxWeights', idx)"
                      *ngIf="idx > 0"
                    >
                      <i class="fas fa-times text-danger"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group form-inline">
              <label for="">Dimensions (in)</label>
              <input
                type="number"
                class="form-control mr-1"
                formControlName="box_length"
                min="0"
                numberOnly
              />
              <input
                type="number"
                class="form-control mr-1"
                formControlName="box_width"
                min="0"
                numberOnly
              />
              <input
                type="number"
                class="form-control mr-1"
                formControlName="box_height"
                min="0"
                numberOnly
              />
            </div>

            <h6>Carton Dimension</h6>

            <div class="form-group form-inline">
              <label for="">Weight</label>
              <div class="weights" formArrayName="cartonWeights">
                <div
                  class="form-inline"
                  *ngFor="
                    let rmk of quoteForm['controls'].cartonWeights['controls'];
                    let idx = index
                  "
                >
                  <div [formGroupName]="idx">
                    <input
                      type="number"
                      class="form-control"
                      formControlName="wv"
                      min="0"
                      numberOnly
                    />
                    <select class="form-control" formControlName="mu">
                      <option
                        *ngFor="let unit of rfqService.weightUnits"
                        [value]="unit"
                      >
                        {{ unit }}
                      </option>
                    </select>
                    <a
                      href="javascript:;"
                      class="mx-2"
                      (click)="addWeight('cartonWeights')"
                      *ngIf="idx == 0"
                    >
                      <i class="fas fa-plus"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="mx-2"
                      (click)="removeWeight('cartonWeights', idx)"
                      *ngIf="idx > 0"
                    >
                      <i class="fas fa-times text-danger"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group form-inline">
              <label for="">Dimensions (in)</label>
              <input
                type="number"
                class="form-control mr-1"
                formControlName="carton_length"
                min="0"
                numberOnly
              />
              <input
                type="number"
                class="form-control mr-1"
                formControlName="carton_width"
                min="0"
                numberOnly
              />
              <input
                type="number"
                class="form-control mr-1"
                formControlName="carton_height"
                min="0"
                numberOnly
              />
            </div>

            <div class="form-group form-inline">
              <label for=""># of units per carton</label>
              <input
                type="number"
                class="form-control"
                formControlName="units_per_carton"
                min="0"
                numberOnly
              />
            </div>

            <h6>Pallet Dimension</h6>
            <div class="form-group form-inline">
              <label for="">Weight</label>
              <div class="weights" formArrayName="palletWeights">
                <div
                  class="form-inline"
                  *ngFor="
                    let rmk of quoteForm['controls'].palletWeights['controls'];
                    let idx = index
                  "
                >
                  <div [formGroupName]="idx">
                    <input
                      type="number"
                      class="form-control"
                      formControlName="wv"
                      min="0"
                      numberOnly
                    />
                    <select class="form-control" formControlName="mu">
                      <option
                        *ngFor="let unit of rfqService.weightUnits"
                        [value]="unit"
                      >
                        {{ unit }}
                      </option>
                    </select>
                    <a
                      href="javascript:;"
                      class="mx-2"
                      (click)="addWeight('palletWeights')"
                      *ngIf="idx == 0"
                    >
                      <i class="fas fa-plus"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="mx-2"
                      (click)="removeWeight('palletWeights', idx)"
                      *ngIf="idx > 0"
                    >
                      <i class="fas fa-times text-danger"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group form-inline">
              <label for="">Dimensions (in)</label>
              <input
                type="number"
                class="form-control mr-1"
                formControlName="pallet_length"
                min="0"
                numberOnly
              />
              <input
                type="number"
                class="form-control mr-1"
                formControlName="pallet_width"
                min="0"
                numberOnly
              />
              <input
                type="number"
                class="form-control mr-1"
                formControlName="pallet_height"
                min="0"
                numberOnly
              />
            </div>

            <div class="form-group form-inline">
              <label for=""># of cartons per pallet</label>
              <input
                type="number"
                class="form-control"
                formControlName="cartons_per_pallet"
                min="0"
                numberOnly
              />
            </div>

            <div class="form-group form-inline">
              <label for=""># of units per pallet</label>
              <input
                type="number"
                class="form-control"
                formControlName="units_per_pallet"
                min="0"
                numberOnly
              />
            </div>

            <div class="form-group">
              <mat-checkbox color="primary" formControlName="is_palletized">
                Palletized
              </mat-checkbox>
            </div>
          </div>
        </div>

        <div class="clearfix"></div>

        <div class="row w1024 action-button">
          <button
            type="button"
            class="btn btn-outline-info mr-1"
            (click)="gotoTab(activeTab - 1)"
            [translate]="'BUTTONS.BACK'"
          >
            <i class="fas fa-arrow-left"></i> Back
          </button>
          <button
            type="button"
            class="btn btn-outline-info"
            (click)="gotoTab(activeTab + 1)"
            [translate]="'BUTTONS.NEXT'"
          >
            Next <i class="fas fa-arrow-right"></i>
          </button>
        </div>
      </mat-tab>

      <mat-tab
        label="Custom Fields"
        *ngFeatureFlag="featureFlag.CUSTOM_FIELDS; isDisabled: false"
      >
        <lum-custom-field-form-group
          [customFieldValues]="rfq?.custom_field_values || []"
          [customFieldObject]="eCustomFieldObject.RFQ"
          (onChange)="onCustomFieldChange($event)"
        ></lum-custom-field-form-group>
      </mat-tab>

      <mat-tab
        label="Others"
        *ngFeatureFlag="featureFlag.CUSTOM_FIELDS; isDisabled: true"
      >
        <div class="form-group">
          <div class="form-group">
            <h4>
              Other Details
              <small
                >Manage custom product details here. Add labels and values
                accordingly.</small
              >
            </h4>
            <div formArrayName="custom_fields">
              <table class="table">
                <thead>
                  <tr>
                    <th>Label</th>
                    <th>Value</th>
                    <th width="40" class="text-right">&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let rmk of quoteForm['controls'].custom_fields['controls'];
                      let idx = index
                    "
                    [formGroupName]="idx"
                  >
                    <td>
                      <input
                        type="text"
                        class="form-control txt"
                        formControlName="l"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        class="form-control txt"
                        formControlName="v"
                      />
                    </td>
                    <td>
                      <a
                        href="javascript:;"
                        class="mx-2 btn"
                        (click)="addField('custom_fields')"
                        *ngIf="idx >= getCustomFieldCount()"
                      >
                        <i class="fas fa-plus"></i>
                      </a>
                      <a
                        href="javascript:;"
                        class="mx-2 btn"
                        (click)="removeField(idx)"
                        *ngIf="idx < getCustomFieldCount()"
                      >
                        <i class="fas fa-times text-danger"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="clearfix"></div>
        <div class="row w1280 action-button">
          <button
            type="button"
            class="btn btn-outline-info"
            (click)="gotoTab(activeTab - 1)"
            [translate]="'BUTTONS.BACK'"
          >
            <i class="fas fa-arrow-left"></i> Back
          </button>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-default"
      (click)="activeModal.dismiss('')"
      [translate]="'BUTTONS.CLOSE'"
    >
      <i class="fas fa-times"></i> Close
    </button>

    <button
      type="button"
      title="Save"
      [disabled]="loading || !quoteForm.valid || isKitItemsValid"
      class="btn btn-info"
      (click)="submit()"
      [ngClass]="{
        'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
      }"
      [translate]="'BUTTONS.SUBMIT_RFQ'"
    >
      <i class="fas fa-save"></i>
      {{ rfq && rfq.id ? 'Save Changes' : 'Create New SKU' }}
    </button>
  </div>
</form>
